import { ROUTE_PATH } from '@shared/constants/route-path.enum';
import { isInsuredFormOpen } from '@shared/store/ui/ui.selectors';
import { MdcBox, MdcIcon, MdcTypography } from 'ids-wc/dist/react/components';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import styles from './Tabbar.module.css';

interface TabbarItemProps {
  title: string;
  icon: string;
  link: ROUTE_PATH;
  disableHiglight?: boolean; //TODO: REMOVE THIS LOGIC. IT WAS NEED FOR LOGOUT ONLY.
  onClick?: () => void;
}
export const TabbarItem = (props: TabbarItemProps) => {
  const { title, icon, link, disableHiglight } = props;
  const isTabbarDisabled = useSelector(isInsuredFormOpen);

  // Ensure the path is absolute by prepending a forward slash if not present
  const absolutePath = link.startsWith('/') ? link : `/${link}`;

  const Disabled = () => (
    <MdcBox p={1} direction="column" display="flex" alignItems="center">
      <MdcBox className={`${styles.iconContainer}`}>
        <MdcIcon title={icon} color="secondaryLight" icon={icon} size="lg" />
      </MdcBox>
      <MdcTypography variant="overline" color="secondaryLight">
        {title}
      </MdcTypography>
    </MdcBox>
  );

  const Active = () => (
    <NavLink to={absolutePath} className={styles.link} onClick={props.onClick}>
      {({ isActive }) => (
        <MdcBox p={1} direction="column" display="flex" alignItems="center">
          <MdcBox className={`${styles.iconContainer} ${isActive && !disableHiglight ? styles.active : ''}`}>
            <MdcIcon
              title={icon}
              color={isActive && !disableHiglight ? 'background' : 'primaryDark'}
              icon={icon}
              size="lg"
            />
          </MdcBox>
          <MdcTypography variant="overline" color="textPrimary">
            {title}
          </MdcTypography>
        </MdcBox>
      )}
    </NavLink>
  );

  return isTabbarDisabled ? <Disabled /> : <Active />;
};
